import { CByteArray } from "./CByteArray";

export class CPonDataRec {
    private m_cnt:number;
    private m_Value:CByteArray= new CByteArray(10);
    private m_Index:Array<number> = new Array<number>(10);
    private m_Sel:number;
    
    public CPonDataRec() {
        this.m_Sel = -1;
    }
    
    public release():void {
    }
    
    public init():void {
        this.m_cnt = 0;
    }
    
    public reset():void {
        this.m_cnt = 0;
        this.m_Sel = -1;
    }
    
    public add(v1:number, idx1:number):void {
        var i:number;
        
        for ( i = 0; i < this.m_cnt; i ++ ) {
            if ( this.m_Value[i] == v1 ) return;
        }
        this.m_Value[this.m_cnt] = v1;
        this.m_Index[this.m_cnt] = idx1;
        this.m_cnt ++;
        //trace("****** CPonDataRec add:", v1, idx1, m_cnt);
    }
    
    public getValue(idx:number):number { return this.m_Value[idx]; }
    public getIndex(idx:number):number { return this.m_Index[idx]; }
    public getCount():number { return this.m_cnt; }
    
    public setSel(sel:number):void {
        this.m_Sel = this.m_Index[sel];
        console.log("****** CPonDataRec:", this.m_Sel);
    }
    public getSel():number { return this.m_Sel; }
}